import { EntityRequestTmppay } from "../../entity/EntityRequestTmppay";

export class DtoRequestTmppaysPutRes extends EntityRequestTmppay {}
